module.exports = __webpack_public_path__ + "static/media/stolik.30ef3dbf.png";